import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyMetadataMapping from '../../../../../../containers/EmptyContainers/MetadataMapping';
import AdminSettingMetadataMappingMapSetting from './MetadataMappingMapSetting';

import { userHasFeature } from '../../../../../../helpers/Features';

const AdminSettingsMetadataMapping = ({
  clientSettings,
  settings,
  handleSettingChange,
}) => {
  const intl = useIntl();

  const downloadFileMetadataMap = settings.download_file_metadata_map;

  const handleMapSettingChange = (setting) => {
    const newMapSetting = downloadFileMetadataMap.value.map(s => {
      if (setting.key === s.key) {
        return setting;
      }
      return s;
    }).map((s, i) => ({
      ...s,
      key: i,
    }));
    handleSettingChange('download_file_metadata_map', newMapSetting);
  };

  const availableTags = clientSettings.download_file_available_exif_tags.filter(c => {
    const findTag = downloadFileMetadataMap.value.find(v => v.tag === c.key);

    return !findTag;
  });

  const handleAddMapping = () => {
    const newMap = {
      key: 'new',
      mapping: 'filename',
      separator: ', ',
      tag: availableTags[0].key,
      simple: true,
    };

    const newMapSetting = [...downloadFileMetadataMap.value, newMap].map((s, i) => ({
      ...s,
      key: i,
    }));

    handleSettingChange('download_file_metadata_map', newMapSetting);
  };

  const handleDeleteMapSetting = (key) => {
    const newMapSetting = downloadFileMetadataMap.value.filter(s => s.key !== key).map((s, i) => ({
      ...s,
      key: i,
    }));
    handleSettingChange('download_file_metadata_map', newMapSetting);
  };

  if (!userHasFeature('download-file-with-metadata')) {
    return (
      <div className="tab-content-wrapper metadata-mapping-wrapper">
        <EmptyMetadataMapping />
      </div>
    );
  }

  return (
    <div className="tab-content-wrapper metadata-mapping-wrapper">
      {!userHasFeature('download-file-with-metadata') ? (
        <div className="tab-content-wrapper metadata-mapping-wrapper">
          <EmptyMetadataMapping />
        </div>
      ) : (
        <>
          <Row>
            <Col>
              <div className="metadata-mapping-header">
                <div className="button-wrapper">
                  <Button
                    color="primary"
                    onClick={() => handleAddMapping()}
                    disabled={availableTags.length === 0}
                    id="AddMappingButton"
                  >
                    <i className="fas fa-plus" />
                    {intl.formatMessage({ defaultMessage: 'Add mapping' })}
                  </Button>
                  {availableTags.length === 0 && (
                  <UncontrolledTooltip fade={false} placement="bottom" target="AddMappingButton">
                    {intl.formatMessage({ defaultMessage: 'All tags are mapped' })}
                  </UncontrolledTooltip>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {downloadFileMetadataMap.value.length > 0 ? (
                <div className="table-wrapper metadata-mapping-table-wrapper">
                  <Table className="metadata-mapping-table" responsive>
                    <thead>
                      <tr>
                        <th className="w-50">{intl.formatMessage({ defaultMessage: 'Map' })}</th>
                        <th>{' '}</th>
                        <th>{intl.formatMessage({ defaultMessage: 'Meta Tag' })}</th>
                        <th className="th-min-content">{' '}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {downloadFileMetadataMap.value.map(s => (
                        <AdminSettingMetadataMappingMapSetting
                          key={s.key}
                          setting={s}
                          availableTags={availableTags}
                          handleMapSettingChange={handleMapSettingChange}
                          handleDeleteMapSetting={handleDeleteMapSetting}
                        />
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <EmptyMetadataMapping handleNewItem={() => handleAddMapping()} />
              )}
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  clientSettings: state.App.settings,
  taxonomies: state.Metadata.taxonomies,
});

AdminSettingsMetadataMapping.propTypes = {
  clientSettings: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AdminSettingsMetadataMapping);
